// <LocationRenameInput> — inline rename row for the appstore Locations
// admin page. Validates 3-80 chars, dirty-checks against initial value,
// disables save while busy.

import { useState } from "react";

export interface LocationRenameInputProps {
  initialName: string;
  saving: boolean;
  onSave(newName: string): void | Promise<void>;
  onCancel(): void;
}

export function LocationRenameInput({
  initialName,
  saving,
  onSave,
  onCancel,
}: LocationRenameInputProps): JSX.Element {
  const [value, setValue] = useState<string>(initialName);
  const trimmed = value.trim();
  const validLength = trimmed.length >= 3 && trimmed.length <= 80;
  const dirty = trimmed !== initialName.trim();
  const canSave = validLength && dirty && !saving;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (canSave) {
          void onSave(trimmed);
        }
      }}
      style={{ display: "flex", gap: "8px", alignItems: "center" }}
    >
      <input
        autoFocus
        className="reb-input"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        minLength={3}
        maxLength={80}
        aria-label="Location display name"
        aria-invalid={!validLength}
        disabled={saving}
      />
      <button
        type="submit"
        className="reb-button reb-button--primary"
        disabled={!canSave}
        aria-label="Save"
      >
        Save
      </button>
      <button
        type="button"
        className="reb-button"
        onClick={onCancel}
        disabled={saving}
      >
        Cancel
      </button>
      {!validLength && (
        <span className="reb-error" role="status" aria-live="polite">
          3-80 characters
        </span>
      )}
    </form>
  );
}
